import React from 'react'
import BeddingTypes from './BeddingTypes'
import ManureTypes from './ManureTypes'

const Manure: React.FC = () => {

  return (
    <div>
      <ManureTypes/>
      <BeddingTypes/>
    </div>
  )

}

export default Manure
